/**
 * Onde o módulo de e-mail está rodando. A loja edita os templates dela em
 * `/loja/:id/email-marketing`; o master edita os templates do sistema em
 * `/plataforma`. Mesmas telas, mesmo editor — muda só a raiz e o nome que a
 * prévia mostra no lugar de `{{loja}}`.
 */
export interface EmailScope {
  kind: 'passbook' | 'platform';
  /** Prefixo das rotas do módulo. */
  root: string;
  /** Nome usado na prévia no lugar de `{{loja}}`. */
  storeName: string;
  idPassbook?: string;
  /** Exemplos para as variáveis `{{...}}` do escopo (a prévia preenche com eles). */
  sampleVariables?: Record<string, string>;
  /** Remetente que a prévia mostra. Sem ele, a loja com `novidades@<domínio>`. */
  sender?: { name: string; email: string };
}

export const PLATFORM_EMAIL_SCOPE: EmailScope = {
  kind: 'platform',
  root: '/plataforma',
  storeName: 'Fixe',
};

export function passbookEmailScope(idPassbook: string, storeName: string): EmailScope {
  return { kind: 'passbook', root: `/loja/${idPassbook}/email-marketing`, storeName, idPassbook };
}
